module.exports = __webpack_public_path__ + "9b323dac7abade6f86db31b2e26d6522.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/katrina-uychaco.jpg
 ** module id = 416
 ** module chunks = 0
 **/